import { defineRule } from 'vee-validate'

const minLength = () => {
  defineRule<any, any[]>('min_length', (value, [compareValue], _ctx: any) => {
    return value.length >= compareValue
  })
}

export default minLength
